export const AiMessageFoot = () => (
  <div className="w-full flex justify-end pt-4 text-blue-700 cursor-pointer">
    <a>Explain </a>
    <p className="mx-1">|</p>
    <a> Export XLS</a>
  </div>
)